import type { FaireProductEntity } from "../../entity_types/product";

export const p_pwdnvgnreq: FaireProductEntity = {
  token: "p_pwdnvgnreq",
  type: "product",
  name: "CWDMD2568_FLYING SLEEVE SHIRRED LAYERED SHORT SLEEVE DRESS",
  brandToken: "b_gd86yguu29",
  brandName: "NINEXIS",
  imageUrl:
    "https://cdn.faire.com/fastly/89ae2dc9b44dfdc2a8ce88e3a59e45a7dd7b782a329ebe172df15359517f68da.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d87e1dea3aa23a358c8406e2517c7234e0222324fd0118bf9332675e4be6915a.jpeg",
    "https://cdn.faire.com/fastly/ccac92b50cde3055177a9bcf1f82890cee61f327b50841b7c5bb117ac9056c5d.jpeg",
    "https://cdn.faire.com/fastly/b3c51bd4f67305a999e6a303975dfb90abe0800dd490fb7d66c8c88744b3c0c4.jpeg",
    "https://cdn.faire.com/fastly/0e37db282e03aef1ece397109a18e1fb120d4242fee840df51d11d06abc20d69.jpeg",
    "https://cdn.faire.com/fastly/f545717f57a93432ff716fe7656500178ff2b93f8a0d5cd661870ccc9dfffcda.jpeg",
    "https://cdn.faire.com/fastly/422dd6091b220673503bad70bb3c46f8f34a2a29d0ce0bdf2e88da4dd653b1f7.jpeg",
    "https://cdn.faire.com/fastly/329c9eec9239e929fb37dfe3c20fefb4d9dc6138dda9b48d9e81327c282881af.jpeg",
    "https://cdn.faire.com/fastly/aa71a3a36aed3c3cd2cf692d75a0b4df434ed9974240e1845cb753e52c0e0aba.jpeg",
    "https://cdn.faire.com/fastly/4910e24081d4188e5492f4cde6224b6fcd0ec5217fdd8ad97dc899bb623dc3f3.jpeg",
    "https://cdn.faire.com/fastly/4a28531cc027f3e0782ac901a28dd9bfebb2a8f7062dce6062dc40a0f1a00369.jpeg",
    "https://cdn.faire.com/fastly/277475c1b3d1f4a20ce5fd0ceb5a1c7d1fbc018b161c2d4ed4bb36765eb5655d.jpeg",
    "https://cdn.faire.com/fastly/fbfac6a045d78a694525c661639ec60dc31df01d3a6b4a36cc508ba8bb81765a.jpeg",
    "https://cdn.faire.com/fastly/2c499d0049626cfd3b4346f9632ee69a41dc7eec283949a1e69c73eabda6ef7f.jpeg",
    "https://cdn.faire.com/fastly/f7816dd148ad25a4e93731f420ac3bf78a8b4d1566976d0105081cc222991198.jpeg",
    "https://cdn.faire.com/fastly/75e6333dd9de7b5e2e101e663f7db4b4481fd653e8afdfe33cc6d92131c7e88f.jpeg",
    "https://cdn.faire.com/fastly/a1470228dcd992d8f1610fae1de7dc0cdde2daee998a896140d56c10bbad7320.jpeg",
    "https://cdn.faire.com/fastly/5bbdd89fccf1a0fca0f102331dba8ac5a3b16a68e4992d78267140258cc72dbe.jpeg",
    "https://cdn.faire.com/fastly/84e83082e4eb531fe5063ad52241987d2bee335bbe423ae61591386477c736dd.jpeg",
    "https://cdn.faire.com/fastly/442fe7f6e2027ab73082e6cc84527e227c61e824aeaf3263793ab6430f280455.jpeg",
    "https://cdn.faire.com/fastly/841e3b8b8b45c6b4424e8ed5ef7281789327c411c192e5797866bae0adb4c8a8.png",
    "https://cdn.faire.com/fastly/7743ba29a107b961334716f0aafafdb0e49930f33d764c2947bd398e4fc7463b.jpeg",
    "https://cdn.faire.com/fastly/d7643db0b27cd178bcbbd9be5336a434ed77ca9e55a5d0a45cff9068805be58f.jpeg",
    "https://cdn.faire.com/fastly/007605a588c454968dd56c608a2d0b1d15d5970120c057f0e853ea648a7ebaa7.jpeg",
    "https://cdn.faire.com/fastly/fb2500dcb6da53467501efcafd7336979f280c05d34bbbb059c93eecaec26f1d.jpeg",
  ],
  priceDollars: 16.48,
  description:
    "Flying sleeve shirred layered short sleeve dress\n95% polyester, 5% spandex\nSize S / M / L / XL / XXL\nMade in China\n\nDresses for women, dress, dresses for women spring, dress forum, dresser, dress pants, dressy tops, dress with pockets, dressed in LALA, dresses spring, dresses for women summer, dresses for women formal, midi dress, floral dress, plus size dress, slit dress, maxi dress, dresses for women winter, dresses for women modest, oversized dress, women dress, loose fit dress, bohemian dress, color block dress, knit dress, western dress, spring apparel, summer apparel, long sleeve dress, shot sleeve dress, patchwork dress, fall dress",
  tags: [],
  msrpDollars: 32.96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:35.154Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
